import $ from "jquery";
import config from '../../config.json';
import auth from '../../auth/auth.react.js';
import React from 'react';
import {
  Card,
  CardHeader,
  CardText
} from 'material-ui/Card';
import {
  Redirect
} from 'react-router-dom'
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Joi from 'joi';
import validation from 'react-validation-mixin';
import strategy from 'joi-validation-strategy';
import CSSModules from 'react-css-modules';
import styles from './all.css';

const create_url = config.server + config.api_path + '/devices/create'

class AddDeviceView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      msg: null,
      redirect: null,
      device_name: '',
      public_key: '',
      username: '',
    }

    this.validatorTypes = {
      device_name: Joi.string()
        .required()
        .min(1)
        .max(50)
        .label('Device ID'),
      public_key: Joi.string()
        .required()
        .min(200)
        .max(800)
        .label('Device Public Key'),
      username: Joi.string()
        .required()
        .min(1)
        .max(50)
        .label('Default Username')
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  handleChange(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleBlur(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
        [name]: value
      },
      this.props.handleValidation(name)
    )
  }

  onSubmit(e) {
    e.preventDefault()
    this.props.validate((err) => {
      if (err) return
      $.post({
          dataType: 'json',
          url: create_url,
          contentType: 'application/json',
          data: auth.with_session({
            device_name: this.state.device_name,
            public_key: this.state.public_key,
            username: this.state.username
          }),
          xhrFields: {
            withCredentials: true
          }
        })
        .done((data) => {
          var _err = data.err
          if (_err && _err.ec === 0) {
            this.setState({
              redirect: '/devices/online'
            })
          } else if (_err && _err.dm === 'not_in') {
            this.props.unauthorized()
          } else if (_err) {
            this.setState({
              msg: _err.em
            })
          }
        })
    })
  }

  getValidatorData() {
    return this.state
  }

  renderHelperText(msg) {
    var err_msg = msg
    if (Array.isArray(msg) && msg.length > 0) {
      err_msg = msg[0]
    }
    return (
      <span styleName="">{err_msg}</span>
    )
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={{pathname: this.state.redirect}} />
    }
    return (
      <Card styleName="dev-card">
        <CardHeader
          title="Add New Device"
          subtitle={this.state.msg}
          actAsExpander={false}
          showExpandableButton={false}
        />
        <CardText>
          <TextField
            floatingLabelText="Device ID"
            floatingLabelFixed={true}
            name="device_name"
            value={this.state.device_name}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            errorText={this.renderHelperText(this.props.getValidationMessages('device_name'))} />
          <br />
          <TextField
            floatingLabelText="Default Username"
            floatingLabelFixed={true}
            name="username"
            value={this.state.username}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            errorText={this.renderHelperText(this.props.getValidationMessages('username'))} />
          <br />
          <TextField
            floatingLabelText="Device Public Key"
            floatingLabelFixed={true}
            name="public_key"
            fullWidth={true}
            multiLine={true}
            rows={11}
            value={this.state.public_key}
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            errorText={this.renderHelperText(this.props.getValidationMessages('public_key'))} />
          <br />

          <RaisedButton styleName="dev-add-button" backgroundColor="#3ed5ad" labelColor="#ffffff" label={"Add Device " + this.state.device_name} onClick={this.onSubmit} disabled={!this.props.isValid()} />
        </CardText>
      </Card>
    )
  }
}

export default validation(strategy)(CSSModules(AddDeviceView, styles))



// WEBPACK FOOTER //
// ./src/views/devices/new.react.js